import { Phone, Mail, MessageCircle } from 'lucide-react'

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-amber-100 to-amber-200 relative overflow-hidden">
      {/* Romantic leaf illustrations */}
      <div className="absolute top-20 left-10 opacity-20">
        <svg className="w-16 h-16 text-green-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      </div>
      <div className="absolute top-40 right-20 opacity-15">
        <svg className="w-12 h-12 text-green-500" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      </div>
      <div className="absolute bottom-32 left-1/4 opacity-10">
        <svg className="w-20 h-20 text-green-300" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      </div>

      <div className="container-spa py-16 relative z-10">
        {/* Intro */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-serif font-bold text-gray-800 mb-4">Have a question or special request?</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're here to help! Get in touch with us for bookings, inquiries, or to design your dreamy Spa~Radise Luxe experience.
          </p>
        </div>

        {/* Layered Card Design */}
        <div className="max-w-4xl mx-auto relative">
          {/* Background cards for layered effect */}
          <div className="absolute inset-0 bg-white/30 rounded-2xl transform rotate-1 shadow-lg"></div>
          <div className="absolute inset-0 bg-white/20 rounded-2xl transform -rotate-1 shadow-lg"></div>
          
          {/* Main card */}
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-white/50">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Contact Methods */}
              <div className="space-y-6">
                <h2 className="text-2xl font-serif font-semibold text-gray-800 mb-6">Get in Touch</h2>
                
                {/* WhatsApp Button */}
                <div className="relative">
                  {/* Background cards for layered effect */}
                  <div className="absolute inset-0 bg-green-400/30 rounded-xl transform rotate-1 shadow-lg"></div>
                  <div className="absolute inset-0 bg-green-500/20 rounded-xl transform -rotate-1 shadow-lg"></div>
                  
                  <a 
                    href="https://wa.me/233537813579" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="relative flex items-center space-x-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-4 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 z-10"
                  >
                    <MessageCircle className="w-6 h-6" />
                    <div>
                      <div className="font-semibold">WhatsApp</div>
                      <div className="text-sm opacity-90">+233 53 781 3579</div>
                    </div>
                  </a>
                </div>

                {/* Call Button */}
                <div className="relative">
                  {/* Background cards for layered effect */}
                  <div className="absolute inset-0 bg-blue-400/30 rounded-xl transform rotate-1 shadow-lg"></div>
                  <div className="absolute inset-0 bg-blue-500/20 rounded-xl transform -rotate-1 shadow-lg"></div>
                  
                  <a 
                    href="tel:+233202468529"
                    className="relative flex items-center space-x-4 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white p-4 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 z-10"
                  >
                    <Phone className="w-6 h-6" />
                    <div>
                      <div className="font-semibold">Call Us</div>
                      <div className="text-sm opacity-90">+233 20 246 8529</div>
                    </div>
                  </a>
                </div>

                {/* Email */}
                <div className="relative">
                  {/* Background cards for layered effect */}
                  <div className="absolute inset-0 bg-purple-400/30 rounded-xl transform rotate-1 shadow-lg"></div>
                  <div className="absolute inset-0 bg-purple-500/20 rounded-xl transform -rotate-1 shadow-lg"></div>
                  
                  <a 
                    href="mailto:sparadiseluxe@gmail.com"
                    className="relative flex items-center space-x-4 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white p-4 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 z-10"
                  >
                    <Mail className="w-6 h-6" />
                    <div>
                      <div className="font-semibold">Email</div>
                      <div className="text-sm opacity-90">sparadiseluxe@gmail.com</div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Social Media */}
              <div className="space-y-6">
                <h2 className="text-2xl font-serif font-semibold text-gray-800 mb-6">Follow Us</h2>
                <p className="text-gray-600 mb-4">Stay connected and see our latest updates</p>
                
                <div className="grid grid-cols-2 gap-4">
                  <a 
                    href="https://www.instagram.com/spa_radise579?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-pink-600 hover:bg-pink-700 text-white p-3 rounded-lg transition-colors duration-200"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.781c-.49 0-.98-.49-.98-.98s.49-.98.98-.98.98.49.98.98-.49.98-.98.98z"/>
                    </svg>
                    <span className="text-sm">Instagram</span>
                  </a>
                  
                  <a 
                    href="https://wa.me/233537813579" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-green-600 hover:bg-green-700 text-white p-3 rounded-lg transition-colors duration-200"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                    </svg>
                    <span className="text-sm">WhatsApp</span>
                  </a>
                  
                  <a 
                    href="https://vm.tiktok.com/ZS9eGpJ16woLp-jVb5G/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-black hover:bg-gray-800 text-white p-3 rounded-lg transition-colors duration-200"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                    </svg>
                    <span className="text-sm">TikTok</span>
                  </a>
                  
                  <a 
                    href="https://www.facebook.com/profile.php?id=61588273271316" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-lg transition-colors duration-200"
                  >
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22 12.07C22 6.48 17.52 2 11.93 2 6.35 2 1.87 6.48 1.87 12.07c0 4.78 3.44 8.74 7.94 9.64v-6.82H7.43v-2.82h2.38V9.41c0-2.35 1.4-3.65 3.55-3.65 1.03 0 2.1.18 2.1.18v2.31h-1.18c-1.16 0-1.52.72-1.52 1.46v1.76h2.59l-.41 2.82h-2.18v6.82c4.5-.9 7.94-4.86 7.94-9.64z" />
                    </svg>
                    <span className="text-sm">Facebook</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
